/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

import {Type} from "@qwoach/class-transformer-wrapper";
import FilterableItem from "@shared/Filterable/FilterableItem";
import BookEntryRef from "@shared/BookWriting/BookEntryRef";
import {BookLayoutPreferenceEnum} from "@shared/BookWriting/BookLayoutPreferenceEnum";
import {BookEntryTypeEnum} from "@shared/BookWriting/BookEntryTypeEnum";
import {ClearanceLevelEnum} from "@shared/Profile/ClearanceLevelEnum";
import {BookStatusEnum} from "@shared/BookWriting/BookStatusEnum";

export default class BookItem extends FilterableItem {

	clientId: string = null
	clientName: string = null
	title: string = null
	bookTypeId: string = null
	bookTypeTitle: string = null
	status: BookStatusEnum = BookStatusEnum.DRAFT
	defaultLayoutPreference: BookLayoutPreferenceEnum = BookLayoutPreferenceEnum.ALTERNATE_SIDES
	primaryColor: string = null
	clearanceLevel: ClearanceLevelEnum = ClearanceLevelEnum.PHI

	@Type(() => BookEntryRef)
	entriesArray: BookEntryRef[] = []

	constructor(options = {}) {
		super(options);
		this.applyOptions(options);
	}

	createEntryRef(options = {}) {
		let entryRef = new BookEntryRef({
			sortOrder: this.getNextSortOrder(),
			layoutPreference: this.defaultLayoutPreference,
			...options,
		})
		this.insertEntryRef(entryRef, options.insertIndex)
		return entryRef
	}

	insertEntryRef(entryRef, insertIndex = null) {
		let entriesArray = this.getEntriesSorted()
		let safeIndex = this.getSafeInsertIndex(insertIndex, entriesArray.length)
		entriesArray.splice(safeIndex, 0, entryRef)
		this.entriesArray = entriesArray
		this.normalizeEntrySortOrder()
	}

	removeEntryRef(entryRefId) {
		this.entriesArray = this.entriesArray.filter(entryRef => entryRef.id !== entryRefId)
		this.normalizeEntrySortOrder()
	}

	moveEntryRef(entryRefId, direction) {
		let entriesArray = this.getEntriesSorted()
		let currentIndex = entriesArray.findIndex(entryRef => entryRef.id === entryRefId)
		let nextIndex = currentIndex + direction
		if(currentIndex >= 0 && nextIndex >= 0 && nextIndex < entriesArray.length){
			let entryRef = entriesArray.splice(currentIndex, 1)[0]
			entriesArray.splice(nextIndex, 0, entryRef)
			this.entriesArray = entriesArray
			this.normalizeEntrySortOrder()
		}
	}

	getEntriesSorted() {
		return [...(this.entriesArray || [])].sort((a, b) => a.sortOrder - b.sortOrder)
	}

	getNextSortOrder() {
		return (this.entriesArray || []).length
	}

	getSafeInsertIndex(insertIndex, maxIndex) {
		let safeIndex = insertIndex
		if(safeIndex === null || safeIndex === undefined){
			safeIndex = maxIndex
		}
		safeIndex = Math.max(0, safeIndex)
		safeIndex = Math.min(safeIndex, maxIndex)
		return safeIndex
	}

	normalizeEntrySortOrder() {
		this.entriesArray.forEach((entryRef, index) => {
			entryRef.sortOrder = index
		})
	}

	hasTitleEntry() {
		return (this.entriesArray || []).some(entryRef => entryRef.entryType === BookEntryTypeEnum.TITLE)
	}

}
